import { Component, OnInit } from '@angular/core';
import { Message } from 'src/app/core/class/message';
import { DocumentService } from 'src/app/core/services/document.service';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { Common } from 'src/app/core/constants/common';
import { Router } from '@angular/router';
import { element } from 'protractor';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-digital-batch-result',
  templateUrl: './sign-digital-batch-result.component.html',
  styleUrls: ['./sign-digital-batch-result.component.scss']
})
export class SignDigitalBatchResultComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  payLoadCheck:any;
  groupId:any;

  dataSource: any;
  displayedColumns: string[] = [
    'STT',
    'contractName',
    'party',
    'result',
    'detail',
    'action'
  ];
  content: any;
  startTime: any;
  startDate: any;
  endTime: any;
  endDate: any;
  notifyData: any;
  notifyInfor: any;
  bread: any;
  data: any;
  isActiveRetry: boolean;
  errorRetry: boolean;
  hasMultiSign: boolean;
  type = 1;
  signerUser:any;

  constructor(
    private message: Message,
    private documentService: DocumentService,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private translate: TranslateService,
  ) {
    if(localStorage.getItem('notifiData') === null ||
      localStorage.getItem('notifiData') === undefined) {
        this.router.navigate(['/home-enterprise/analysis-report']);
    }
    if(localStorage.getItem("notitficationTypeSign")){
      this.type = JSON.parse(localStorage.getItem("notitficationTypeSign"));
      if(this.type == 90){
        this.signerUser = this.translate.instant('headertable.sign_party');
      }
      else {
        this.signerUser = this.translate.instant('headertable.sign_party');
      }
    }
    this.notifyData = JSON.parse(localStorage.getItem('notifiData'));
    this.content = this.notifyData.content;
    this.startTime = this.content.match(Common.REGEX_TIME)[0];
    this.endTime = this.content.match(Common.REGEX_TIME)[1];
    this.startDate = this.content.match(Common.REGEX_DATE)[0];
    this.endDate = this.content.match(Common.REGEX_DATE)[1];
    this.isActiveRetry = false;
    this.errorRetry = false;
    this.hasMultiSign = false;
  }

  ngOnInit() {
    this.blockUI.reset();
    this.blockUI.start('');
    this.documentService.signGroupDetail(this.notifyData.contractId).subscribe(res => {
      this.blockUI.stop();
      if (!res || !res.data) {
        return;
      }
      this.data = res.data;
      this.dataSource = res.data.details;
      this.groupId = res.data.group.id;
      this.dataSource.forEach(el => {
        el.nameOrCode = el.code + ' - ' + el.name;
        el.allName = el.signers.join(", ");
        el.allEmail = el.emails.join(", ");
        el.signerConfirms = el.signerConfirms.join(", ");
      });
      if((this.data.noOfFailed + this.data.noOfProcessing) == this.data.noOfSelected)
        this.isActiveRetry = true
    });
  }

  renderStatus(status) {
    switch (status) {
      case -1:
        return this.message.getMessage('sign_contract_flow.error');
      case 0:
        return this.message.getMessage('sign_contract_flow.process');
      case 1:
        return this.message.getMessage('sign_contract_flow.success');
      default:
        return '';
    }
  }

  renderStatusColor(status): object {
    switch (status) {
      case -1:
        return { 'color': 'red', 'border': '1px solid red', 'border-radius': '5px' };
      case 0:
        return { 'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px' };
      case 1:
        return { 'color': 'green', 'border': '1px solid green', 'border-radius': '5px' };
      default:
        return {};
    }
  }

  getSignType(signType: number) {
    switch (signType) {
      case 0:
        return this.message.getMessage('enterprise-certificate_management.cbx_certificate_type.cbx_sign-number-server');
      case 1:
        return this.message.getMessage('enterprise-certificate_management.cbx_certificate_type.cbx_usb_token');
      case 2:
        return this.message.getMessage('enterprise-certificate_management.cbx_certificate_type.cbx_card_CA');
      case 3:
        return this.message.getMessage('enterprise-certificate_management.cbx_certificate_type.cbx_OTP');
      case 4:
        return this.message.getMessage('enterprise-certificate_management.cbx_certificate_type.cbx_sign-number-server');
      case 10:
        return this.message.getMessage('enterprise-certificate_management.cbx_certificate_type.cbx_CLOUD_CA');
      default:
        return 'N/a';
    }
  }

  // Navigate to view detail document
  openViewDialog(id) {
    if(this.type == 90){
      this.toNavigate('/home-enterprise/sign-confirm-document/' + id, { goFrom: 'waitConfirm' });
    }
    if(this.type == 99){
      this.toNavigate('/home-enterprise/digital-contract/' + id + '/view');
    }
    else {
      this.toNavigate('/home-enterprise/view-document/' + id, { goFrom: 'waitSign' });
    }
  }

  /**
   * Set params for to navigate
   */
  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
    };

    this.router.navigate([route], { queryParams });
  }

  navigateSignedContract() {
    if(this.type == 90){
      this.toNavigate('/home-enterprise/search-waiting-confirm-document/', { goFrom: 'signBatch' });
    }else {
      this.toNavigate('/home-enterprise/search-document-sign/', { goFrom: 'signBatch' });
    }
  }

  openSignPage() {
    this.blockUI.reset();
    this.blockUI.start('');
    if(this.type == 90){
      this.payLoadCheck = {
        contracts: this.dataSource.map(el => el.id),
        type:4,
        groupId:this.groupId
      }
    }
    else  {
      this.payLoadCheck = {
        contracts: this.dataSource.map(el => el.id),
        groupId:this.groupId
      }
    }
    this.documentService.checkProcessingContract(
      this.payLoadCheck
    ).subscribe(
      res => {
        this.blockUI.stop();
        if(!res)
          return;

        // debugger
        if(res.success === true){
          localStorage.setItem('signBatchContracts', JSON.stringify(this.dataSource))
          this.navigateSignedContract();
        } else {
          if(res.code === '0x002007')
            this.hasMultiSign = true;
          else this.errorRetry = true;
        }
      }
    )
  }

  /**
   *
   *  "cbx_sign-number-server": "HSM",
      "cbx_usb_token": "Usb Token",
      "cbx_card_CA": "Sim CA",
      "cbx_HSM": "HSM",
      "cbx_OTP": "OTP",
      "cbx_CLOUD_CA": "Ký số từ xa"

      SIGNATURE_SERVER = 0
      USB = 1
      SIM_CA = 2
      OTP = 3
      HSM = 4
      SIGN_IMAGE = 5
      SIGN_NO_CERT = 6
      CLOUD_CA = 10
   */

}
